import React, { createContext, useContext, useRef, useState } from 'react';
import {
  AzureInstallationContextValue,
  AzureInstallationProviderProps,
  ConnectionMethod,
} from './types';

const AzureInstallationContext = createContext<
  AzureInstallationContextValue | undefined
>(undefined);

export const AzureInstallationProvider = ({
  children,
}: AzureInstallationProviderProps) => {
  const installationIdRef = useRef(crypto.randomUUID());
  const [consentGranted, setConsentGranted] = useState(false);
  const [consentError, setConsentError] = useState<string | undefined>(
    undefined,
  );
  const [syncedCountState, setSyncedCountState] = useState(0);
  const [connectionMethod, setConnectionMethod] =
    useState<ConnectionMethod | null>(null);
  const [azureTenantId, setAzureTenantId] = useState<string | undefined>(
    undefined,
  );

  return (
    <AzureInstallationContext.Provider
      value={{
        installationId: installationIdRef.current,
        consentGranted,
        setConsentGranted,
        consentError,
        setConsentError,
        syncedCount: syncedCountState,
        setSyncedCount: setSyncedCountState,
        connectionMethod,
        setConnectionMethod,
        azureTenantId,
        setAzureTenantId,
      }}
    >
      {children}
    </AzureInstallationContext.Provider>
  );
};

export const useAzureInstallation = (): AzureInstallationContextValue => {
  const context = useContext(AzureInstallationContext);

  if (!context) {
    throw new Error(
      'useAzureInstallation must be used within AzureInstallationProvider context.',
    );
  }

  return context;
};
